export default __webpack_public_path__ + "static/media/loader-review2.9209a225.svg";